import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "col-md-12 mr-auto ml-auto"
}
const _hoisted_2 = { class: "wizard-container" }
const _hoisted_3 = {
  class: "card card-wizard active",
  "data-color": "primary"
}
const _hoisted_4 = { class: "card-header historico-header" }
const _hoisted_5 = { class: "historico-actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row g-3" }
const _hoisted_10 = { class: "col-xl-5 col-lg-6" }
const _hoisted_11 = { class: "historico-region" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "col-xl-7 col-lg-6" }
const _hoisted_14 = { class: "historico-region historico-form" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-4 mb-3" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "col-md-8 mb-3" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = {
  key: 0,
  class: "col-md-4 mb-3"
}
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-md-8 mb-3" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-md-8 mb-3" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "col-md-8 mb-3" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = {
  key: 2,
  class: "col-md-8 mb-3"
}
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "col-12 mb-3" }
const _hoisted_31 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccessDenied = _resolveComponent("AccessDenied")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DropDownListTipoMovimentacao = _resolveComponent("DropDownListTipoMovimentacao")!
  const _component_DropDownListEscola = _resolveComponent("DropDownListEscola")!
  const _component_DropDownListSala = _resolveComponent("DropDownListSala")!
  const _component_DropDownListFornecedor = _resolveComponent("DropDownListFornecedor")!
  const _component_Form = _resolveComponent("Form")!

  return (!_ctx.permissaoTela.visualizar)
    ? (_openBlock(), _createBlock(_component_AccessDenied, {
        key: 0,
        msg: "Você não tem permissão para visualizar esta tela. Caso precise de acesso, procure o suporte."
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Form, {
              onSubmit: _ctx.onSubmit,
              "validation-schema": _ctx.schema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      to: { name: 'patbem' },
                      class: "btn btn-warning btn-sm"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("i", {
                          class: "uil uil-search",
                          "aria-hidden": "true"
                        }, null, -1),
                        _createTextVNode("Pesquisar ", -1)
                      ]))]),
                      _: 1
                    }),
                    (_ctx.permissaoTela.incluir)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-secondary btn-sm",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.novo && _ctx.novo(...args)))
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("i", {
                            class: "uil uil-plus",
                            "aria-hidden": "true"
                          }, null, -1),
                          _createTextVNode("Novo ", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.podeGravar)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "submit",
                          class: "btn btn-primary btn-sm",
                          disabled: _ctx.loadingSave
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("i", {
                            class: "ri-save-line",
                            "aria-hidden": "true"
                          }, null, -1),
                          _createTextVNode("Salvar ", -1)
                        ]))], 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    (_ctx.permissaoTela.excluir)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "btn btn-danger btn-sm",
                          disabled: !_ctx.model.pesHistoricoId || _ctx.loadingSave,
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("i", {
                            class: "uil uil-trash-alt",
                            "aria-hidden": "true"
                          }, null, -1),
                          _createTextVNode("Excluir ", -1)
                        ]))], 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ConsulteGrid, {
                          columns: _ctx.gridColumns,
                          "data-source": _ctx.dataSource,
                          actions: true,
                          "titulo-actions": "Selecionar",
                          "hide-header": ""
                        }, {
                          actions: _withCtx((context) => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-primary btn-sm",
                              onClick: ($event: any) => (_ctx.selecionar(context.row))
                            }, " Selecionar ", 8, _hoisted_12)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _cache[14] || (_cache[14] = _createElementVNode("label", null, "Data", -1)),
                              _createVNode(_component_Field, {
                                name: "data",
                                class: "form-control",
                                type: "date",
                                modelValue: _ctx.model.data,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.data) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "data" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_Field, {
                                name: "tipoMovimentacao",
                                modelValue: _ctx.model.tipoMovimentacao,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.model.tipoMovimentacao = $event))
                              }, {
                                default: _withCtx(({ handleChange }) => [
                                  _createVNode(_component_DropDownListTipoMovimentacao, {
                                    modelValue: _ctx.model.tipoMovimentacao,
                                    "onUpdate:modelValue": 
               (value) => {
                _ctx.model.tipoMovimentacao = value;
                handleChange(value);
               }
              
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "tipoMovimentacao" })
                            ])
                          ]),
                          (_ctx.mostrarRetorno)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Data de Retorno", -1)),
                                  _createVNode(_component_Field, {
                                    name: "dataRetorno",
                                    class: "form-control",
                                    type: "date",
                                    modelValue: _ctx.model.dataRetorno,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.dataRetorno) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, { name: "dataRetorno" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.mostrarDestino)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    (_openBlock(), _createBlock(_component_DropDownListEscola, {
                                      key: `escola-${_ctx.formKey}-${_ctx.model.gesEscolaId ?? 'novo'}`,
                                      modelValue: _ctx.model.gesEscolaId,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.gesEscolaId) = $event)),
                                      label: "Escola Destino"
                                    }, null, 8, ["modelValue"])),
                                    _createVNode(_component_ErrorMessage, { name: "gesEscolaId" })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    (_openBlock(), _createBlock(_component_DropDownListSala, {
                                      key: `sala-${_ctx.formKey}-${_ctx.model.gesEscolaId ?? 'nova'}`,
                                      modelValue: _ctx.model.gesSalaId,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.gesSalaId) = $event)),
                                      gesEscolaId: _ctx.model.gesEscolaId,
                                      label: "Sala/Ambiente"
                                    }, null, 8, ["modelValue", "gesEscolaId"])),
                                    _createVNode(_component_ErrorMessage, { name: "gesSalaId" })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _cache[16] || (_cache[16] = _createElementVNode("label", null, "Localização", -1)),
                                    _createVNode(_component_Field, {
                                      name: "localizacao",
                                      class: "form-control",
                                      type: "text",
                                      modelValue: _ctx.model.localizacao,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.localizacao) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, { name: "localizacao" })
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.mostrarFornecedor)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_DropDownListFornecedor, {
                                    modelValue: _ctx.model.gesFornecedorManutencaoId,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.gesFornecedorManutencaoId) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, { name: "gesFornecedorManutencaoId" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _cache[17] || (_cache[17] = _createElementVNode("label", null, "Observação", -1)),
                              _createVNode(_component_Field, {
                                name: "observacao",
                                as: "textarea",
                                class: "form-control",
                                rows: "4",
                                modelValue: _ctx.model.observacao,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.observacao) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "observacao" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ]))
}